/**
 *
 * Loader
 *
 */
import React, { Component } from "react"
import { Spin } from "antd"
import "./index.less"

const Loader = (props) => {

  const isiframe = window.top !== window.self

  return (
    <div className="loader" style={{ height: props.height || "90vh", backgroundColor: isiframe ? "#F9F9F9" : "#FFFFFF" }}>
      <Spin
        size="large"
        style={{ width: "40px !important", height: "40px !important" }}
      />
    </div>
  )
}

export default Loader
